import { useEffect } from 'react';

import type { Theme } from '@/stores/ui.store';

import { getAmbientTint } from './ambient-theme.utils';

const TICK_MS = 60_000;

export function useAmbientTintEffect(theme: Theme) {
  useEffect(() => {
    const writeTint = () => {
      const { tint } = getAmbientTint(new Date(), theme);
      document.documentElement.style.setProperty('--ambient-tint', tint);
    };
    writeTint();
    const id = window.setInterval(writeTint, TICK_MS);
    return () => window.clearInterval(id);
  }, [theme]);
}
